module.exports = __webpack_public_path__ + "img/1.5003d627.png";